import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
import { WizFile } from '@wizbii/models';

@Directive({
  selector: 'app-file-input[appMaxFileSize]',
  providers: [{ provide: NG_VALIDATORS, useExisting: MaxFileSizeValidator, multi: true }],
})
export class MaxFileSizeValidator implements Validator {
  static readonly MAX_FILE_SIZE = 8 * 1024 * 1024;

  private _maxSize: number;
  private onValidatorChange: () => void;

  @Input('appMaxFileSize')
  set maxSize(maxSize: number) {
    this._maxSize = maxSize || MaxFileSizeValidator.MAX_FILE_SIZE;

    if (this.onValidatorChange) {
      this.onValidatorChange();
    }
  }

  registerOnValidatorChange(fn: () => void): void {
    this.onValidatorChange = fn;
  }

  validate(control: { value: WizFile }): ValidationErrors | null {
    return !control.value || control.value.domFile.size <= this._maxSize ? null : { maxFileSize: true };
  }
}
